import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  getChallengeById,
  getReviewsByChallengeId,
  getAllTags
} from '../../services/ChallengesService';
import ChallengeDetail from '../../components/ChallengeDetail';

function ChallengeDetailPage() {
  const { challengeId } = useParams();
  const [challenge, setChallenge] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const [challengeData, reviewData, tagsData] = await Promise.all([
          getChallengeById(challengeId),
          getReviewsByChallengeId(challengeId),
          getAllTags()
        ]);
        setChallenge(challengeData);
        setReviews(reviewData);
        setAllTags(tagsData);
      } catch (err) {
        console.error('Error loading challenge details, reviews, or tags:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [challengeId]);

  const handleChallengeUpdated = (updatedChallenge) => {
    setChallenge(updatedChallenge);
  };

  if (loading) return <div>Loading challenge...</div>;
  if (!challenge) return <div>Challenge not found.</div>;

  return (
    <div className="challenge-detail">
      <ChallengeDetail
        challenge={challenge}
        reviews={reviews}
        allTags={allTags}
        onChallengeUpdated={handleChallengeUpdated}
      />
    </div>
  );
}

export default ChallengeDetailPage;
